export const HASURA_ENDPOINT_DEV = "hasura.tryhyperclapper.click/v1/graphql";
export const BASE_ENDPOINT =
  "https://us-central1-hyperclapper.cloudfunctions.net";

// export const BASE_ENDPOINT = "http://127.0.0.1:5001/hyperclapper/us-central1";

// export const BACKEND_URL = "http://localhost:4004";
// export const BACKEND_URL_OLD =
//   "https://imwei6b550.execute-api.us-east-1.amazonaws.com/prod";

// export const BACKEND_URL =
//   "https://g6h6vevmvmqraqn6cjjhfutkfe0oqvhm.lambda-url.us-east-1.on.aws";

export const BACKEND_URL = "https://api.tryhyperclapper.click";

// The agent server (docs/engagement/MCP_SERVER_PLAN.md section 6): the
// permission page at /connect asks it what an AI app wants, and tells it the
// customer's answer.
export const MCP_URL = "https://mcp.hyperclapper.com";

// export const BACKEND_FUNCTION_URL = "http://localhost:4004";
// export const BACKEND_FUNCTION_URL =
//   "https://cwq53q3xwueyb4yp4nvzhgyzdu0ynaqb.lambda-url.us-east-1.on.aws"; //for longer running functions

// export const PUPPETEER_BACKEND_URL = "http://localhost:4004";
// export const PUPPETEER_BACKEND_URL_OLD =
//   "https://gsq6wimvw64oonlqzkx4ipjlay0ojvwe.lambda-url.us-east-1.on.aws"; //for puppeteer aws lambd

// Every hc-puppeteer call goes through our own CloudFront edge (F40 step 5).
// Some customers' antivirus, DNS filter or network blocks the shared
// *.lambda-url.us-east-1.on.aws domain outright while letting our own domain
// through, so on the raw Function URL they could not boost or connect at all.
export const PUPPETEER_BACKEND_URL = "https://worker.tryhyperclapper.click";

// export const SANDBOX_PUPPETEER_BACKEND_URL =
//   "https://y4xx2zsmkglsxfbdjztfchmdcm0eawyi.lambda-url.us-east-1.on.aws";

export const firebaseConfig = {
  apiKey: "AIzaSyBWfkVMXoJswG_8SGTX-F8Qwbrj8Fp13P0",
  authDomain: "hyperclapper.firebaseapp.com",
  projectId: "hyperclapper",
  storageBucket: "hyperclapper.appspot.com",
  messagingSenderId: "711915071503",
  appId: "1:711915071503:web:fd350eb83ade180a6c9b7a",
  measurementId: "G-0WEZSTNB4P",
};

// export const SQUARE_APP_ID = "sandbox-sq0idb-_9DobTRwDcPefw9-V9IUqw";
// export const SQUARE_LOCATION_ID = "LA6W26ZRT180T";

export const SQUARE_APP_ID = "sq0idp-Ds5qBUeN2-0vxl3trqADxg";
export const SQUARE_LOCATION_ID = "LKST69344K0T3";

export const NEW_EXTENSION =
  "https://chromewebstore.google.com/detail/hyperclapper-ai-powered-n/gkmphkjkphmhhlldbbkdlnccbikjcngl";

export const MAX_POST_ENGAGED_PROFILES = 50;
